import { Component, Input, OnInit } from '@angular/core';
import { CustomerReviewDAO } from '../../../../../core/services/dao/customerReviewDAO';
import { CustomerReviewRatingType } from 'anchor-shared/lib/model/enum/customer-review-rating-type';
import { CustomerReview } from 'anchor-shared/lib/model/entity/customerReview';
import { CustomerReviewCategory } from 'anchor-shared/lib/model/entity/customerReviewCategory';
import { Subscription } from 'rxjs';
import { CustomerReviewStatus } from 'anchor-shared/lib/model/enum/customer-review-status';

@Component({
  selector: 'app-manage-customer-review',
  templateUrl: './manage-customer-review.component.html',
  styleUrls: ['./manage-customer-review.component.scss'],
})
export class ManageCustomerReviewComponent implements OnInit {
  @Input() charterId: number;

  customerReview: CustomerReview;
  publicReview: CustomerReviewCategory;
  privateReview: CustomerReviewCategory;
  displayFullPublicReview: boolean = false;
  displayFullPrivateReview: boolean = false;
  loading: boolean = true;
  subs: Subscription[] = [];

  constructor(private customerReviewDAO: CustomerReviewDAO) {}

  ngOnInit(): void {
    this.initCustomerReviews();
  }

  // reviews tab
  initCustomerReviews() {
    const reviewSub = this.customerReviewDAO
      .getReviewByCharterId(this.charterId)
      .subscribe((customerReview) => {
        this.customerReview = customerReview;
        if (customerReview) {
          this.publicReview = customerReview.customerReviewCategories.find(
            (x) => x.ratingType === CustomerReviewRatingType.Public,
          );
          this.privateReview = customerReview.customerReviewCategories.find(
            (x) => x.ratingType === CustomerReviewRatingType.Private,
          );
        }
        this.loading = false;
      });
    this.subs.push(reviewSub);
  }

  handleReviewStatus() {
    const newStatus =
      this.customerReview.status === CustomerReviewStatus.Revoked
        ? CustomerReviewStatus.Complete
        : CustomerReviewStatus.Revoked;
    const reviewStatusUpdateSub = this.customerReviewDAO
      .updateReviewStatus(this.charterId, newStatus)
      .subscribe((updatedReview) => {
        this.customerReview = updatedReview;
        this.publicReview = updatedReview.customerReviewCategories.find(
          (x) => x.ratingType === CustomerReviewRatingType.Public,
        );
        this.privateReview = updatedReview.customerReviewCategories.find(
          (x) => x.ratingType === CustomerReviewRatingType.Private,
        );
      });
    this.subs.push(reviewStatusUpdateSub);
  }
}
